import { Injectable, inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { EnvironmentService } from '@core/services/environment.service';
import { ImpersonationService } from '@features/impersonation/services/impersonation.service';
import { UserService } from '@features/user/services/user.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class IsVerifiedGuard {
    private userService = inject(UserService);
    private router = inject(Router);
    private environmentService = inject(EnvironmentService);
    private impersonationService = inject(ImpersonationService);

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        // Shell prerendering: auth resolves in the browser only.
        if (this.environmentService.isServer()) {
            return true;
        }
        return this.userService
            .isVerified() // This method will need to be added to UserService
            .pipe(
                map((isVerified: boolean) =>
                    isVerified
                        ? isVerified
                        : this.router.parseUrl(
                              this.impersonationService.toImpersonatedPath(
                                  '/verify-email'
                              )
                          )
                )
            );
    }
}
